// extracted by mini-css-extract-plugin
module.exports = {"college-filters-edit-form-header":"_1NQ_AUedkZlNLd4gnESgwA"};